import IconAmex from 'assets/icons/payment/amex.svg';
import IconApplePay from 'assets/icons/payment/apple-pay.svg';
import IconKlarna from 'assets/icons/payment/klarna.svg';
import IconMastercard from 'assets/icons/payment/mastercard.svg';
import IconPaypal from 'assets/icons/payment/paypal.svg';
import IconTwint from 'assets/icons/payment/twint.svg';
import IconVisa from 'assets/icons/payment/visa.svg';
import IconIdeal from 'assets/icons/payment/ideal.svg';
import cn from 'classnames';
import { useConfig } from 'config/use-config';
import { PaymentMethod } from 'constants/payment-method';
import { FC } from 'react';

const iconClassName = 'w-8 lg:w-10';

const PaymentMethodIcon: FC<{ method: PaymentMethod }> = ({ method }) => {
  switch (method) {
    case PaymentMethod.PAYPAL:
      return <IconPaypal className={iconClassName} />;
    case PaymentMethod.VISA:
      return <IconVisa className={iconClassName} />;
    case PaymentMethod.MASTERCARD:
      return <IconMastercard className={iconClassName} />;
    case PaymentMethod.AMEX:
      return <IconAmex className={iconClassName} />;
    case PaymentMethod.KLARNA:
      return <IconKlarna className={iconClassName} />;
    case PaymentMethod.TWINT:
      return <IconTwint className={iconClassName} />;
    case PaymentMethod.APPLE_PAY:
      return <IconApplePay className={iconClassName} />;
    case PaymentMethod.IDEAL:
      return <IconIdeal className={iconClassName} />;
    default:
      return null;
  }
};

interface PaymentMethodIconsProps {
  className?: string;
}

const PaymentMethodIcons: FC<PaymentMethodIconsProps> = ({ className }) => {
  const { paymentMethods } = useConfig();
  return (
    <div className={cn('flex items-center justify-center gap-2', className)}>
      {paymentMethods
        .filter((method) => method !== PaymentMethod.APPLE_PAY || Boolean(window.ApplePaySession)) // checks if apple pay is available
        .map((method) => (
          <PaymentMethodIcon key={method} method={method} />
        ))}
    </div>
  );
};

export default PaymentMethodIcons;
